import Vue from 'vue'
import App from './App.vue'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '../public/fonts/vazir.css'
import '../public/bootstrap-rtl.min.css'

import Vuex from 'vuex'
import { store } from './store/store'
import { routes } from './routes'
import VueRouter from 'vue-router';

import Notifications from 'vue-notification'
import vuePersian from 'vue-persian'


Vue.use(Notifications)
Vue.use(vuePersian)
Vue.use(VueRouter)
Vue.use(Vuex)
const router = new VueRouter({
    routes,
    mode: 'history'
})

Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
new Vue({
    store,
    router,
    render: h => h(App),
}).$mount('#app')